module.exports = __webpack_public_path__ + "static/img/senior-send.eae34492.png";